import React, { useState, useEffect, useCallback } from 'react';
import FormInput from '../../../shared/components/ui/FormInput';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Button from '../../../shared/components/ui/Button';
import deleteIcon from '../../../shared/assets/svg/cancel_icon.svg';
import Multiselect from 'multiselect-react-dropdown';
import toast from 'react-hot-toast';
import { getAllCommonTaskTemplates } from '../../services/api/implementation/impl';
import { useQuery } from '@tanstack/react-query';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const validationSchema = yup.object().shape({
  name: yup.string().required('Task name is required'),
  sections: yup.string().required('Select if section is required')
});

const AddEditWorkType = ({
  onClose,
  onSubmit,
  isSubmitting,
  modalType,
  selectedTask,
  setModalType
}) => {
  const userId = Cookies.get('userId');
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control
  } = useForm({
    resolver: yupResolver(validationSchema)
  });
  console.log(selectedTask);

  // Prefill form when editing
  useEffect(() => {
    if (modalType === 'Edit' && selectedTask) {
      setValue('name', selectedTask.label || selectedTask.name || '');
      setValue('type', selectedTask.type || '');
      setValue('sections', selectedTask.sections ? 'Yes' : 'No');
    }
  }, [modalType, selectedTask, setValue]);

  const onSubmitForm = (formValues) => {
    const payload = {
      name: formValues.name,
      type: formValues.type,
      sections: formValues.sections === 'Yes'
    };
    onSubmit(payload);
  };

  return (
    <>
      <div className="flex flex-col justify-between items-start gap-4">
        <span className="text-lg border-b-[1px] border-stone-200 w-full pb-2">
          WorkType Details
        </span>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit(onSubmitForm)} className="flex flex-col gap-4 pt-6">
        <div className="flex justify-between items-center w-full">
          <FormInput
            width={48}
            label="Name"
            register={register}
            register_key="name"
            type="text"
            isRequired
            errors={errors.name}
          />
          <div className="flex justify-between flex-col items-start w-[48%] gap-2">
            <label className="text-gray-600" htmlFor="drawing">
              Sections *
            </label>
            <div className="flex justify-start items-center w-[48%] gap-2 space-x-4">
              <label className="flex items-center space-x-1">
                <input type="radio" name="sections" value="Yes" {...register('sections')} />
                <span>Yes</span>
              </label>

              <label className="flex items-center space-x-1">
                <input type="radio" name="sections" value="No" {...register('sections')} />
                <span>No</span>
              </label>
            </div>
            {errors.sections && <span className="text-red-500">{errors.sections.message}</span>}
          </div>
        </div>
        <div className="flex justify-between items-center w-full">
          <FormInput
            width={48}
            label="Type"
            register={register}
            register_key="type"
            type="dropdown"
            options={[
              {
                value: '',
                label: 'Select Type',
                disabled: true,
                selected: true
              },
              {
                value: 'Common',
                label: 'Common'
              },
              {
                value: 'Accomodation',
                label: 'Accomodation'
              }
            ]}
            errors={errors.type}
            isRequired
          />
        </div>
        {/* Submit Buttons */}
        <div className="w-full flex justify-end items-center space-x-4 mt-8">
          <Button type="button" onClick={onClose} displayType="secondary">
            Cancel
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            {modalType === 'Add' ? 'Submit' : 'Update'}
          </Button>
        </div>{' '}
      </form>
    </>
  );
};

export default AddEditWorkType;
